import React from "react";
import Loadable from "react-loadable";
import CircularProgress from "../../../components/CircularProgress";
// ToDo:: change loading ...
const AsyncIndex = Loadable({
  loader: () => import("./Assign"),
  loading: () => <CircularProgress className="gx-loader-400" />,
});

export default AsyncIndex;
